import {
  DownloadDocumentMenuItem,
  DownloadDocumentMenuItemProps,
} from '../../menuItems';
import { DocumentsTableRowData } from '../DocumentsTable.types';

interface DownloadDocumentActionItemProps
  extends Omit<DownloadDocumentMenuItemProps, 'documentId'> {
  row: DocumentsTableRowData;
}

/**
 * @description This an action item component for use by the table ActionButtonRenderer
 */
export function DownloadDocumentActionItem({
  row,
  ...props
}: DownloadDocumentActionItemProps) {
  return <DownloadDocumentMenuItem documentId={row.id} {...props} />;
}
